import React from "react"

import { Wrapper } from "./styles"

const Footer = props => {
  return (
    <Wrapper>
      <h4>© B2R Solution - Depuis 1986</h4>
    </Wrapper>
  )
}

export default Footer
